import { getListArtist, getDetailArtist, setBlockArtist, setUnblockArtist,
  deleteArtistByEmail, updateCutCalculation, getListArtistBio, editBio, approvalBio,
  resendEmail, getListArtistDraft, addArtist, updateArtist, publishArtist, getUrlStatement,
  getListArtistApplication, getDetailArtistApplication, approveArtistApplication, rejectArtistApplication } from '@/services/artist';

const getters = {
  listArtist: state => state.listArtist,
  listArtistBio: state => state.listArtistBio,
  listArtistDraft: state => state.listArtistDraft,
  listArtistApplication: state => state.listArtistApplication,
  artistApplication: state => state.artistApplication,
  getArtist: state => state.artist,
  per_page: state => state.per_page,
};

const actions = {
  async requestListArtist({ commit }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListArtist(filter);
      commit('SET_LIST_ARTIST', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailArtist({ commit }, idArtist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDetailArtist(idArtist);
      commit('SET_DETAIL_ARTIST', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestBlockArtist({ commit, dispatch }, idArtist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setBlockArtist(idArtist);
      dispatch('requestListArtist', { per_page: 20 });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUnblockArtist({ commit, dispatch }, idArtist) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setUnblockArtist(idArtist);
      dispatch('requestListArtist', { per_page: 20 });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestDeleteArtist({ commit, dispatch }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteArtistByEmail(email);
      dispatch('requestListArtist', { per_page: 20 });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateCutCalculation({ commit, dispatch, rootGetters }, cutData) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await updateCutCalculation(cutData, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListArtist', { per_page: 20 });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListArtistBio({ commit }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListArtistBio(filter);
      commit('SET_LIST_ARTIST_BIO', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditBio({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editBio(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListArtistBio', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestApprovalBio({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await approvalBio(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListArtistBio', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestResendEmail({ commit, dispatch, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await resendEmail(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      dispatch('requestListArtist', { per_page: 20 });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListArtistDraft({ commit }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListArtistDraft(filter);
      commit('SET_LIST_ARTIST_DRAFT', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddArtist({ commit, dispatch, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addArtist(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success Add Artist', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-add-artist-admin' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestUpdateArtist({ commit, dispatch, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await updateArtist(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success Add Artist', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-update-artist-admin' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPublishArtist({ commit, dispatch, rootGetters }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await publishArtist(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success Add Artist', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-publish-artist-admin' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetUrlStatement({ commit, dispatch, rootGetters }, id) {
    let resp = null
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      resp = await getUrlStatement(id, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Success Add Artist', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-publish-artist-admin' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return resp
  },
  async requestListArtistApplication({ commit }, filter) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getListArtistApplication(filter);
      commit('SET_LIST_ARTIST_APPLICATION', response);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailArtistApplication({ commit }, id) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getDetailArtistApplication(id);
      commit('SET_ARTIST_APPLICATION', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestApproveArtistApplication({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await approveArtistApplication(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Application approved', errorCode: null }, { root: true });
      if (filter) {
        dispatch('requestListArtistApplication', filter);
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-approve-artist-application' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestRejectArtistApplication({ commit, dispatch, rootGetters }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await rejectArtistApplication(data, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'Application rejected', errorCode: null }, { root: true });
      if (filter) {
        dispatch('requestListArtistApplication', filter);
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-reject-artist-application' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_ARTIST(state, listArtist) {
    state.listArtist = listArtist;
  },
  SET_LIST_ARTIST_BIO(state, listArtistBio) {
    state.listArtistBio = listArtistBio;
  },
  SET_LIST_ARTIST_DRAFT(state, listArtistDraft) {
    state.listArtistDraft = listArtistDraft;
  },
  SET_LIST_ARTIST_APPLICATION(state, listArtistApplication) {
    state.listArtistApplication = listArtistApplication;
  },
  SET_ARTIST_APPLICATION(state, artistApplication) {
    state.artistApplication = artistApplication;
  },
  SET_DETAIL_ARTIST(state, artist) {
    state.artist = artist;
  },
};

export default {
  namespaced: true,
  state: {
    listArtist: [],
    listArtistBio: [],
    listArtistDraft: [],
    listArtistApplication: [],
    artistApplication: {},
    per_page: 6,
    artist: {
      id: 1,
      name: '',
      email: '',
      dob: '',
      bio: '',
      genre: '',
      avatar: '',
      musicverse_cut: 0,
      artist_cut: 0,
    },
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Artist/index.js